import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import ConstOffsetTimeZone from '../../main-layout/sidebar/save-system-setting/Const';
import { REDUCER_NAME } from './../../main-layout/sidebar/reducer';

class TimeZoneHandle extends React.Component {
  render() {
    const { time, format, timeZone, i18n } = this.props;
    const timeZoneOffset =
      timeZone in ConstOffsetTimeZone.listTimeZoneByKey
        ? ConstOffsetTimeZone.listTimeZoneByKey[timeZone].offSet
        : '+07:00';
    const convertTimeToUtc = moment(time)
      .utc()
      .lang(i18n.locale);
    return convertTimeToUtc
      .utcOffset(timeZoneOffset)
      .format(format)
      .toString();
  }
}

TimeZoneHandle.defaultProps = {
  time: null,
  format: 'HH:mm:ss',
  timeZoneOffset: '+07:00',
};

const mapStateToProps = state => ({
  i18n: state.i18n,
  tz: null,
  timeZone: state[REDUCER_NAME].settingSystem.dataSystem.timeZone,
});

export default connect(mapStateToProps)(TimeZoneHandle);
